import React, { useRef } from "react";

const ClaimComment = ({ data }) => {
  const closeRef = useRef();

  return (
    <div className='container'>
      <div className='my-3 text-center'>
        <h3 className='text-primary fs-4'>{data.user_role} Comment</h3>
      </div>
      {data?.approve_comment?.length > 0 ? (
        <div>
          <p>APPROVE COMMENT:</p>
          {data.approve_comment.map((item, i) => (
            <div
              className='p-1 rounded-3 mb-1'
              key={i}
              style={{ background: "#F1F0F1" }}
            >
              <span>{item}</span>
            </div>
          ))}
        </div>
      ) : null}
      {data?.decline_comment?.length > 0 ? (
        <div className='my-3'>
          <p>DECLINE COMMENT:</p>
          {data.decline_comment.map((item, i) => (
            <div
              className='p-1 rounded-3 mb-1'
              key={i}
              style={{ background: "#F1F0F1" }}
            >
              <span>{item}</span>
            </div>
          ))}
        </div>
      ) : null}
      <div className='d-flex justify-content-end'>
        <div className='d-grid'>
          <button
            ref={closeRef}
            className='btn btn-sm mt-2 px-3 bg-secondary text-white'
            data-bs-dismiss='modal'
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClaimComment;
